import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';
import { AutoText } from '../../../components/pdf/autoText'; 

const styles = StyleSheet.create({
  table: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  row: {
    flexDirection: 'row',
    borderBottom: '1px solid #000',
  },
  cell: {
    padding: 5,
    borderRight: '1px solid #000',
    verticalAlign: 'middle',
  },
  headerCell: {
    fontWeight: 'bold',
    backgroundColor: '#f2f2f2',
  },
  // Column specific styles
  srNoCell: {
    width: '5%',
  },
  detailsCell: {
    width: '55%',
  },
  pageNoCell: {
    width: '40%',
  },
  // Nested table styles
  nestedTableContainer: {
    flexDirection: 'row',
  },
  nestedTable: {
    width: '95%', // 55% + 40% - some padding adjustment
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    marginTop: 5,
  },
  nestedRow: {
    flexDirection: 'row',
  },
  nestedCell: {
    flex: 1,
    padding: 3,
    borderRight: '1px solid #000',
    borderBottom: '1px solid #000',
    height: 80,
  },
  nestedHeaderCell: {
    fontWeight: 'bold',
    backgroundColor: '#f0f0f0',
    height: 30,
    textAlign: 'center',
  },
  // Special row for spanning columns
  spanningRow: {
    flexDirection: 'row',
    borderBottom: '1px solid #000',
  },
  emptyCell: {
    width: '5%',
    padding: 5,
    borderRight: '1px solid #000',
  },
  spanningContent: {
    width: '95%',
    padding: 5,
  },
});

const Form15 = ({ result }) => {
  const tableData = [
    ['17', 'Date from which pension is to commence', result.employeeName],
    ['18', `a.
Pension rules opted/ eligible
b.
Whether nomination made for
1.
Family pension
2.
Death-cum-Retirement gratuity`, 
    `Pension Rules 1982 & 2010

Yes
Yes`],
    ['19', `Date of applicant's birth by Christian era`, result.dateOfBirth],
    ['20', 'Height', result.height],
    ['21', 'Identification marks', result.splMark],
    ['22', 'Thumb and finger impressions.', 'Below'],
  ];

  return (
    <View size="A4" style={style.page}> 
      <View style={style.solidLine}/>
      {/* Table */}
      <View style={styles.table}>
        {/* Table Data */}
        {tableData.map(([srNo, details, value], index) => (
          <View style={styles.row} key={index}>
            <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
            <Text style={[styles.cell, styles.detailsCell]}>{details}</Text>
            <View style={[styles.cell, styles.pageNoCell]}>
              {value}
            </View>
          </View>
        ))}
        
        {/* Special row for nested table spanning columns 2 and 3 */}
        <View style={styles.spanningRow}>
          <View style={styles.emptyCell}></View>
          <View style={styles.spanningContent}>
            {/* Nested Table */}
            <View style={styles.nestedTable}>
              {/* Header Row */}
              <View style={styles.nestedRow}>
                <Text style={[styles.nestedCell, styles.nestedHeaderCell]}>Little Finger</Text>
                <Text style={[styles.nestedCell, styles.nestedHeaderCell]}>Ring Finger</Text>
                <Text style={[styles.nestedCell, styles.nestedHeaderCell]}>Middle Finger</Text>
                <Text style={[styles.nestedCell, styles.nestedHeaderCell]}>Index Finger</Text>
                <Text style={[styles.nestedCell, styles.nestedHeaderCell]}>Thumb</Text>
              </View>
              {/* Data Rows */}
              <View style={styles.nestedRow}>
                <Text style={styles.nestedCell}></Text>
                <Text style={styles.nestedCell}></Text>
                <Text style={styles.nestedCell}></Text>
                <Text style={styles.nestedCell}></Text>
                <Text style={styles.nestedCell}></Text>
              </View>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default Form15;